import { format } from 'date-fns';
import styled from 'styled-components';
import { DAY_MONTH, MONTH_DAY } from '../../../../../constants';
import { renderStyledElementStyles } from '../../../helpers';
import { useRootSelector } from '../../../../../store/hooks';
import { selectSiteHeaderData } from '../../../../../store/features/siteHeader';

const Logo = styled.img`
  max-width: 100%;
`;

const Title = styled.div`
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.vStyles.elements?.tile?.title,
    )}
  text-decoration: underline;
`;

const StartDate = styled.div`
  margin-top: 10px;
  font-size: 12px;
  color: #000;

  span {
    &:first-child {
      font-weight: bold;
    }

    &:last-child {
      font-weight: 300;
    }

    &:nth-child(2) {
      margin: 0 5px;
    }
  }
`;

const Overlay = styled.span`
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  content: '';

  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.vStyles.elements?.tile?.overlay,
    )}
`;

const Anchor = styled.a`
  display: block;

  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.vStyles.elements?.tile)}

  text-decoration: none;

  &:hover ${Title} {
    ${({ theme }) =>
      renderStyledElementStyles(
        theme,
        theme.module.vStyles.elements?.tile?.title?.hoverSettings,
      )}
  }

  &:hover ${Overlay} {
    ${({ theme }) =>
      renderStyledElementStyles(
        theme,
        theme.module.vStyles.elements?.tile?.overlay?.hoverSettings,
      )}
  }
`;

export default function EventTile({ event }) {
  const { dateFormat = DAY_MONTH } = useRootSelector(selectSiteHeaderData);

  return (
    <Anchor href={event.url} target="_blank" rel="noopener noreferrer">
      <span className="embed-responsive embed-responsive-1by1">
        <span className="embed-responsive-item">
          {event.picture?.thumbnail_url && (
            <Logo src={event.picture.thumbnail_url} />
          )}
          <Overlay />
        </span>
      </span>
      <Title>{event.title}</Title>
      {event.start_date && (
        <StartDate>
          <span>
            {format(
              event.start_date,
              dateFormat === MONTH_DAY ? 'MMM dd' : 'dd MMM',
            )}
          </span>
          <span>|</span>
          <span>
            {format(
              event.start_date,
              dateFormat === MONTH_DAY ? 'h:mm aa' : 'H:mm',
            )}
          </span>
        </StartDate>
      )}
    </Anchor>
  );
}
